import { render } from "./ClientConfiguracionFacturacion.vue?vue&type=template&id=59d26f32&scoped=true"
import script from "./ClientConfiguracionFacturacion.vue?vue&type=script&lang=js"
export * from "./ClientConfiguracionFacturacion.vue?vue&type=script&lang=js"

import "./ClientConfiguracionFacturacion.vue?vue&type=style&index=0&id=59d26f32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59d26f32"]])

export default __exports__